import { render } from "./tpl-title.vue?vue&type=template&id=e27d6762&scoped=true"
import script from "./tpl-title.vue?vue&type=script&lang=js"
export * from "./tpl-title.vue?vue&type=script&lang=js"

import "./tpl-title.vue?vue&type=style&index=0&id=e27d6762&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e27d6762"],['__file',"src/views/dragger/template/tpl-title.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e27d6762"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e27d6762', __exports__)) {
    console.log('reload')
    api.reload('e27d6762', __exports__)
  }
  
  module.hot.accept("./tpl-title.vue?vue&type=template&id=e27d6762&scoped=true", () => {
    console.log('re-render')
    api.rerender('e27d6762', render)
  })

}


export default __exports__